module.exports = __webpack_public_path__ + "img/icon_sport_type_22.d560bc24.png";